// extracted by mini-css-extract-plugin
export var dividerContainer = "_a3-0";
export var line = "_a3-1";